import templateUrl from './edit-product-order-details.component.html';

export const EditProductOrderDetailsComponent = {
    templateUrl,
    require: {
        form: "^^?form"
    },
    bindings: {
        productOrder: "<",
        productOrderStatuses: "<"
    },
    controller: class {

        $onInit() {
        }

        onAddProductOrderStatus() {
            this.productOrder.StatusHistory.unshift({
                IsNew: true
            });
        }

        onDeleteProductOrderStatus({ status }) {
            this.productOrder.StatusHistory = this.productOrder.StatusHistory.filter(s => s !== status);
        }

    }
}
